export default "__VITE_ASSET__DZ88eWWi__"